'use client';

import React__default from 'react';

var FacebookIcon = function () {
    return (React__default.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("path", { d: 'M10.3333 22.4V12.4H7V9.06669H10.3333V7.27669C10.3333 3.88752 11.9842 2.40002 14.8008 2.40002C16.15 2.40002 16.8633 2.50002 17.2008 2.54586V5.73336H15.28C14.0842 5.73336 13.6667 6.36419 13.6667 7.64252V9.06669H17.1708L16.695 12.4H13.6667V22.4H10.3333Z', fill: '#888' })));
};
var FacebookIcon$1 = React__default.memo(FacebookIcon);

export { FacebookIcon$1 as default };
//# sourceMappingURL=index.js.map
